import React from 'react';
import {Progress} from "reactstrap";
import Utils from "../../common/Utils";
import {Line} from "react-chartjs-2";
import moment from 'moment';
import PropTypes from 'prop-types';

const ChartDefaultRange ={
    min: 5,
    max: 5
};

const ChartDayRange = {
    min: 7,
    max: 6
};

const ChartWeekRange = {
    min: 7,
    max: 6
};


function getTimeFrameRange(timeFrame) {

    switch (timeFrame){
        case "week":
            return ChartWeekRange;
        case 'day':
            return ChartDayRange;
        default:
            return ChartDefaultRange;
    }

}

const InfoBar = (props) => {
    return <div>
        <i className={props.icon}></i>
        <span className="title">{props.title}</span>
        <span className="value">{ props.percent || 0 }%</span>
        <div className="bars">
            <Progress className="progress-xs" color={Utils.getPercentageColor(props.percent)} value={props.percent} />
        </div>
    </div>
};

const CreationLineChart = (props) => {

    const data = {
        labels: props.labels ||  (props.data  ? props.data.map((i) => moment(i.time).format(props.labelFormat || 'MMM')) : []),
        datasets: [
            {
                label: props.title,
                fill: props.hasOwnProperty("fill") ? props.fill : true,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: props.data ? props.data.map((i) => i.peak) : null
            }
        ]};

    return <Line data={data} height={ props.height ? props.height : null } options={{maintainAspectRatio: false }} />
};

CreationLineChart.propTypes = {
    labels: PropTypes.array,
    data: PropTypes.array,
    title: PropTypes.string,
    fill: PropTypes.bool,
    labelFormat: PropTypes.string
};

export {
    InfoBar,
    CreationLineChart,
    getTimeFrameRange
}


// WEBPACK FOOTER //
// ./src/views/Dashboard/DashboardCommon.js